<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-alert
        variant="danger"
        :show="alertErrors.length > 0"
        class="mb-0"
      >
        <div
          v-for="(row, index) in alertErrors"
          :key="index"
          class="alert-body"
        >
          <feather-icon

            icon="InfoIcon"
            class="mr-50"
          />
          {{ row }}
        </div>
      </b-alert>
      <b-card
        aria-hidden="true"
        class="mb-0"
      >
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >

          <!-- User Info: Input Fields -->
          <b-form
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >
            <b-row>

              <!-- Field: Payment Method Title -->
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="Name"
                  rules="required"
                >
                  <b-form-group
                    label="Payment Method Name"
                    label-for="payment-method-name"
                  >
                    <b-form-input
                      id="payment-method-name"
                      v-model="userData.payment_method_title"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Field: Status -->
              <b-col
                cols="12"
                md="6"
              >

                <b-form-group
                  label="Status"
                  label-for="status"
                >
                  <v-select
                    v-model="userData.status"
                    :v-if="!loading"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="statusOptions"
                    :reduce="val => val.value"
                    :clearable="false"
                    input-id="status"
                  />
                </b-form-group>
              </b-col>

            </b-row>

            <b-row>

              <!-- Field: Account 1 -->
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="Account 1"
                  rules="required"
                >
                  <b-form-group
                    label="Account 1"
                    label-for="account-1"
                  >
                    <b-form-input
                      id="account-1"
                      v-model="userData.account_1"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Field: Account 2 -->
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="Account 2"
                  rules="required"
                >
                  <b-form-group
                    label="Account 2"
                    label-for="account-2"
                  >
                    <b-form-input
                      id="account-2"
                      v-model="userData.account_2"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

            </b-row>

            <!-- Action Buttons -->
            <b-button
              variant="primary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              type="submit"
            >
              Save Changes
            </b-button>
            <b-button
              variant="outline-secondary"
              type="reset"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            >
              Reset
            </b-button>
          </b-form>

        </validation-observer>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BButton, BRow, BCol, BFormGroup, BFormInput, BForm,
  // BTable,
  BCard,
  // BCardHeader, BCardTitle, BFormCheckbox,
  BFormInvalidFeedback, BOverlay, BAlert,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { ref/* , onUnmounted  */ } from '@vue/composition-api'
import axios from '@axios'
import store from '@/store'

import formValidation from '@core/comp-functions/forms/form-validation'
import { required, alphaNum, email } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PaymentMethodStoreModule from '../paymentMethodStoreModule'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    // BTable,
    BCard,
    // BCardHeader,
    // BCardTitle,
    // BFormCheckbox,
    vSelect,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
    BOverlay,
    BAlert,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      selected: [],
      alertErrors: [],
    }
  },
  setup(props) {
    // const roleOptions = []

    // const loginOptions = []
    const statusOptions = ['Enabled', 'Disabled']
    const loading = true
    const loader = true
    const headingArray = []

    const permissionsData = []
    const refInputEl = ref(null)
    const previewEl = ref(null)
    const permissions = []
    // const loginOptionsArgs = []

    const requestArgs = [
      // { request: '/users/get-login-options', param: 'loginOptions' },
      // { request: '/role-management/get-user-roles', param: 'roleOptions' },
    ]

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(props.userData)

    return {
      avatarText,
      // roleOptions,
      statusOptions,
      // loginOptions,
      permissionsData,
      loading,
      loader,
      refInputEl,
      previewEl,
      headingArray,
      // inputImageRenderer,
      permissions,
      // loginOptionsArgs,
      requestArgs,
      refFormObserver,
      getValidationState,
      resetForm,
      BFormInvalidFeedback,
    }
  },
  watch: {
    userData: {
      deep: true,
      handler(newValue) {
        console.log('Selected payment method changed', newValue.permissions)
      },
    },
  },
  created() {
    this.loader = false
    // this.getUserMultipleOptions()
    // this.getPermissions()
  },
  methods: {
    onSubmit() {
      this.loader = true
      const PAYMENT_METHOD_APP_STORE_MODULE_NAME = 'app-payment-method'

      // Register module
      if (!store.hasModule(PAYMENT_METHOD_APP_STORE_MODULE_NAME)) store.registerModule(PAYMENT_METHOD_APP_STORE_MODULE_NAME, PaymentMethodStoreModule)
      const permissions = []
      this.headingArray.forEach(heading => {
        console.log('heading', heading)
        // const result = this.userData.permissions.filter(word => word.includes(heading))
        // const assignedPermissions = []
        // result.forEach(item => {
        //   const ret = item.replace(`${heading}_`, '')
        //   assignedPermissions.push(ret)
        // })
        // permissions.push({ assignedPermissions, heading })
      })

      const data = { ...this.userData, permissions }
      // console.log('--->', data)
      store.dispatch('app-payment-method/editPaymentMethod', data)
        .then(() => {
          // console.log('done', response)
          this.$router.replace('/payment-methods/list')
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Payment Method Updated',
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: 'Payment Method successfully Updated!',
                },
              })
            })
        })
        .catch(error => {
          console.log(error)
          this.alertErrors = error.data.message
          // console.log('error**', this.alertErrors)
          this.loader = false
        })
    },
    userIsSelected(checkBox) {
      return this.selected.includes(checkBox)
    },
    async getPermissions() {
      const newArr = []
      axios
        .get('/role-management/default-permissions')
        .then(response => {
          const headingData = Object.keys(response.data.data)
          this.headingArray = headingData
          let newObj = null
          headingData.forEach(element => {
            newObj = response.data.data[element]
            delete newObj.model
            newArr.push(newObj)
          })
          this.permissionsData = newArr
          this.loader = false
          // console.log('new_Arr', this.permissionsData)
        })
        .catch(error => console.log('ERROR', error))
    },

    async getUserMultipleOptions() {
      try {
        await Promise.all(
          this.requestArgs
            .map(REQUEST => axios
              .get(REQUEST.request)
              .then(res => {
                if (REQUEST.param === 'loginOptions') {
                  this.loginOptions = [...res.data.data]
                }
                if (REQUEST.param === 'roleOptions') {
                  this.roleOptions = [...res.data.data]
                }
              })),
        )
          .then(() => {
            this.loading = false
          })
      } catch (error) {
        console.log('options error', error)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.spinner-border{
  width: 6rem;
  height: 6rem;
}
</style>
